import { ReactNode, memo } from 'react';
import { Button, ButtonProps } from './Button';
import { cn } from '@/lib/utils';

export interface IconButtonProps extends Omit<ButtonProps, 'children'> {
  /** Ícono a mostrar */
  icon: ReactNode;
  /** Label para accesibilidad */
  'aria-label': string;
  /** Tamaño del botón */
  size?: 'sm' | 'md' | 'lg';
  /** Si es circular */
  circular?: boolean;
}

const sizeClasses = {
  sm: 'h-8 w-8 p-0',
  md: 'h-10 w-10 p-0',
  lg: 'h-12 w-12 p-0',
};

/**
 * IconButton (memoized) - Botón que solo muestra un ícono
 * 
 * Uso:
 * ```tsx
 * <IconButton icon={<XIcon />} aria-label="Cerrar" variant="ghost" />
 * <IconButton icon={<EditIcon />} aria-label="Editar" size="sm" circular />
 * ```
 */
export const IconButton = memo(function IconButton({
  icon,
  size = 'md',
  circular = false,
  className,
  ...props
}: IconButtonProps) {
  return (
    <Button
      {...props}
      size={size}
      className={cn(
        sizeClasses[size],
        circular && 'rounded-full',
        className
      )}
    >
      {icon}
    </Button>
  );
});








